import { combineReducers } from 'redux';
import components from './components';
import routes from './routes';
import today from './today';
import upcoming from './upcoming';
import pending from './pending';
import archived from './archived';
import upcomingEvents from './upcoming-events';
import availableEvents from './available-events';
import ROItem from './ro-item';
import ROPicklist from './ro-picklist';
import ROItemOptions from './ro-item-options';
import trackingMethodOptions from './tracking-method-options';
import orderItems from './order-items';
import reservationExport from './export';
import reports from './reports';

export default combineReducers({
  components,
  routes,
  today,
  upcoming,
  pending,
  archived,
  upcomingEvents,
  availableEvents,
  ROItem,
  ROPicklist,
  ROItemOptions,
  trackingMethodOptions,
  orderItems,
  export: reservationExport,
  reports
});
